'use strict'

import angular from 'angular'

export class LoadingFactory {
  constructor($q, $injector, $timeout, $rootScope) {
    'ngInject'
    // super($q);
    Object.assign(
      this,
      { $q, $injector, $timeout, $rootScope },
      {
        counter: 0,
      },
    )
  }

  request = (config) => {
    const $rootScope = this.$injector.get('$rootScope')
    if (this.counter === 0) {
      $rootScope.$broadcast('loadr', true)
    }
    this.counter++
    return config
  }

  response = (response) => {
    const $rootScope = this.$injector.get('$rootScope')
    this.$timeout(() => {
      this.counter--
      if (this.counter === 0) {
        $rootScope.$broadcast('loadr', false)
      }
    }, 300)
    return response
  }

  responseError = (response) => {
    const $rootScope = this.$injector.get('$rootScope')
    this.$timeout(() => {
      this.counter--
      if (!this.counter) {
        $rootScope.$broadcast('loadr', false)
      }
    }, 300)
    return this.$q.reject(response)
  }

  static factory($q, $injector, $timeout, $document) {
    'ngInject'
    return new LoadingFactory($q, $injector, $timeout, $document)
  }
}

export class AuthFactory {
  constructor($q, $injector) {
    'ngInject'
    Object.assign(this, { $q, $injector })
  }

  /**
   * add session token to all $http requests
   * @param config
   * @returns {*}
   */
  request = (config) => {
    if (config.url.startsWith('/api')) {
      const SessionService = this.$injector.get('SessionService')
      if (SessionService.get('token')) config.headers['x-session-token'] = SessionService.get('token')
    }
    return config
  }

  /**
   * handle response errors from $http calls
   * TODO handle unaithorized redirec
   * @param response
   */
  responseError = (response) => {
    // handle unauthorized
    if (response.status !== 401) return this.$q.reject(response)
    if (response.config.url === '/api/sessions') return this.$q.reject(response)

    console.info('must handle unauthorized redirect here', response)
    return this.$q.reject(response)
  }

  static factory($q, $injector) {
    'ngInject'
    return new AuthFactory($q, $injector)
  }
}

export const authConfigBlock = ($httpProvider) => {
  'ngInject'
  $httpProvider.interceptors.push('LoadingFactory')
  $httpProvider.interceptors.push('AuthFactory')
}

export function authRunBlock($transitions) {
  'ngInject'
  // Matches if the destination state's data property has a truthy 'requiresAuth' property
  const requiresAuthCriteria = {
    to: (state) => state.data && state.data.requiresAuth,
  }

  // Function that returns a redirect for the current transition to the login state
  // if the user is not currently authenticated (according to the AuthService)
  const redirectToLogin = (transition) => {
    let SessionService = transition.injector().get('SessionService')
    let $state = transition.router.stateService

    // if user is not logged in
    if (!SessionService.isAuthenticated()) {
      // redirect to login if there is no token in session storage
      if (!SessionService.get('token')) return $state.target('login', undefined, { location: true })

      // if authenticating by session token fails, also redirect to login
      return SessionService.authenticateByToken().catch((err) => {
        return $state.target('login', undefined, { location: true })
      })
    }
  }

  // Register the "requires auth" hook with the TransitionsService
  $transitions.onBefore(requiresAuthCriteria, redirectToLogin, { priority: 10 })
}



// WEBPACK FOOTER //
// ./app/shared/services/auth.service.js